<template>
  <div class="marquee-wrapper">
    <ul class="ps-0 mb-0 list-unstyled marquee">
      <li class="marquee-note">
        <span>أسرع سيرفر IPTV وثبات كامل بدون تقطيع</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>تفعيل فوري وآمن لجميع الأجهزة خلال دقائق</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>أضخم مكتبة أفلام ومسلسلات مترجمة ومحدثة يومياً</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>بث مباشر دقة 4K و VIP لكافة البطولات الرياضية</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>دعم فني متواصل على مدار 24 ساعة عبر الواتساب</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>اشتراكات مرنة ومخصصة للاستخدام الفردي والعائلي</span>
      </li>
      <li class="marquee-note">
        <span>أسرع سيرفر IPTV وثبات كامل بدون تقطيع</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>تفعيل فوري وآمن لجميع الأجهزة خلال دقائق</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>أضخم مكتبة أفلام ومسلسلات مترجمة ومحدثة يومياً</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>بث مباشر دقة 4K و VIP لكافة البطولات الرياضية</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>دعم فني متواصل على مدار 24 ساعة عبر الواتساب</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>اشتراكات مرنة ومخصصة للاستخدام الفردي والعائلي</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MarqueeText",
});
</script>